/* Currently the only way to achieve type narrowing via Array.includes.
 * Reference: https://github.com/microsoft/TypeScript/issues/26255#issuecomment-502899689
 */
export default function includes(arr, elem) {
  return arr.includes(elem);
}